import { render, staticRenderFns } from "./NewVehicle.vue?vue&type=template&id=6a98f80c"
import script from "./NewVehicle.vue?vue&type=script&lang=js"
export * from "./NewVehicle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports